import { FC } from 'react';
import { Minimize2 } from 'lucide-react';

interface CallHeaderProps {
  title: string;
  studentName?: string;
  videoId?: string;
  timerDisplay?: string;
  onMinimize?: () => void;
}

export const CallHeader: FC<CallHeaderProps> = ({ title, studentName, videoId, onMinimize }) => {
  return (
    <div className="flex items-center justify-between p-4 pb-0">
      <div className="flex justify-between w-full gap-4">
        <div className="flex gap-4">
          {onMinimize && (
            <button
              onClick={onMinimize}
              className="p-2 rounded-full! text-(--neutral-black-NB800) hover:bg-neutral-100 hover:text-neutral-700 transition-colors cursor-pointer"
              aria-label="Minimize to picture-in-picture"
            >
              <Minimize2 size={20} />
            </button>
          )}
          <div className="flex flex-col">
            <h1 className="text-2xl font-bold text-(--neutral-black-NB800)! m-0!">{title}</h1>
            <p className="[font-family:var(--font-montserrat)] text-(--neutral-black-NB800) font-medium m-0!">
              Video ID: {videoId}
            </p>
            {studentName && (
              <p className="[font-family:var(--font-montserrat)] text-(--neutral-black-NB800) font-medium m-0!">
                Student: {studentName}
              </p>
            )}
          </div>
        </div>
      </div>

      {/* <div className="bg-(--neutral-black-NB100) text-(--neutral-black-NB800) font-medium px-4 py-2 rounded-full!">
        {timerDisplay}
      </div> */}
    </div>
  );
};
